import { render, staticRenderFns } from "./Reg2Service.vue?vue&type=template&id=634f633d"
import script from "./Reg2Service.vue?vue&type=script&lang=js"
export * from "./Reg2Service.vue?vue&type=script&lang=js"
import style0 from "./Reg2Service.vue?vue&type=style&index=0&id=634f633d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports